// Helpers for building Monri Components transaction params from a user/billing profile.

// Monri requires ch_country as alpha2/alpha3/ISO-numeric. Our billing address stores
// the full common country name, so map the markets we serve; default to RS.
export function toAlpha2Country(country) {
  if (!country) return 'RS'
  const map = {
    'serbia': 'RS',
    'bosnia and herzegovina': 'BA',
    'croatia': 'HR',
    'montenegro': 'ME',
    'slovenia': 'SI',
    'north macedonia': 'MK',
    'macedonia': 'MK',
    'germany': 'DE',
    'austria': 'AT',
    'united states': 'US',
    'united states of america': 'US',
  }
  const key = String(country).trim().toLowerCase()
  if (map[key]) return map[key]
  // Already a 2-3 letter code — pass it through uppercased.
  if (/^[a-zA-Z]{2,3}$/.test(country)) return country.toUpperCase()
  return 'RS'
}

// Build the transactionParams object for monri.confirmPayment. Buyer email falls back
// to the account email when the billing address has none.
export function buildTransactionParams(user, orderInfo) {
  const u = user || {}
  const billing = (u.settings && u.settings.billing_address) || {}

  const fullName = [billing.firstname, billing.lastname].filter(Boolean).join(' ').trim()
    || billing.company
    || u.name
    || 'N/A'

  return {
    address: billing.address || 'N/A',
    fullName,
    city: billing.city || 'N/A',
    zip: billing.zipcode || '11000',
    phone: billing.phone || '+381000000000',
    country: toAlpha2Country(billing.country),
    email: billing.email || u.email || '',
    orderInfo: orderInfo || 'Subscription payment',
  }
}
